import { Reveal } from "../../components/Reveal";
import { PageHero, CtaBand } from "../../components/ui";
import { VALUES } from "../../data/site";

export default function Values() {
    return (
        <>
            <PageHero
                eyebrow="Company — Our Values"
                lines={["Five values. One standard", "of delivery."]}
                trail={[{ label: "Home", path: "/" }, { label: "Company" }, { label: "Our Values" }]}
            />
            <section className="bg-paper">
                <div className="container-x py-20 sm:py-24 lg:py-28">
                    <ul className="border-t border-line">
                        {VALUES.map((v, i) => (
                            <li key={v.n} className="border-b border-line">
                                <Reveal delay={i * 0.05}>
                                    <div className="group grid items-baseline gap-4 py-10 sm:grid-cols-12 sm:py-12" data-testid={`value-card-${v.n}`}>
                                        <span className="font-mono text-[11px] tracking-[0.2em] text-blue sm:col-span-1">{v.n}</span>
                                        <h3 className="font-display text-3xl font-bold tracking-[-0.01em] text-ink transition-colors group-hover:text-blue sm:col-span-4 sm:text-4xl">
                                            {v.title}
                                        </h3>
                                        <p className="body-lg sm:col-span-7">{v.body}</p>
                                    </div>
                                </Reveal>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
            <CtaBand cta="Work with us" />
        </>
    );
}
